import { render, staticRenderFns } from "./WorkCard.vue?vue&type=template&id=ce204628&scoped=true"
import script from "./WorkCard.vue?vue&type=script&lang=js"
export * from "./WorkCard.vue?vue&type=script&lang=js"
import style0 from "./WorkCard.vue?vue&type=style&index=0&id=ce204628&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce204628",
  null
  
)

export default component.exports